import { useState, useEffect } from "react";

// Фото со скелетоном: пока не загрузилось — пульсирующий серый плейсхолдер,
// после загрузки — плавное появление. При смене src скелетон показывается снова.
export default function SmartImage({ src, alt = "", style, imgStyle, dark = false }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);
  }, [src]);

  return (
    <div style={{ position: "relative", overflow: "hidden", ...style }}>
      {!loaded && (
        <div
          className="img-skeleton"
          style={{
            position: "absolute",
            inset: 0,
            background: dark ? "rgba(255,255,255,.06)" : undefined,
          }}
        />
      )}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
          opacity: loaded ? 1 : 0,
          transition: "opacity .3s ease",
          ...imgStyle,
        }}
      />
    </div>
  );
}

// Предзагрузка списка изображений (для соседних кадров галереи).
export function preloadImages(srcs) {
  srcs.forEach((s) => {
    if (!s) return;
    const img = new Image();
    img.src = s;
  });
}
